<div>
    <app-student-nav-header *ngIf="partnerLogo" [partnerLogo]="partnerLogo" (mobileMenuToggle)="toggleMobileMenu()">
    </app-student-nav-header>
</div>

<div>
    <app-student-content-forms [isMobileMenuOpen]="isMobileMenuOpen" (closeMobileMenu)="closeMobileMenu()">
    </app-student-content-forms>
</div>